<template>
    <transition name="fade">
        <div id="screen-end">
            <div class="column-topic" style="background-color: #3e6dc5">
                <img style="margin-bottom: 38px" src="@/assets/svg/book.svg" alt="Livre">
                <h1>Documentation</h1>
                <p>Would like to return to one or more documents ?</p>
                <button style="color: #3e6dc5">Find them</button>
            </div>
            <div class="column-topic" style="background-color: #2a41b6">
                <img src="@/assets/svg/appointment.svg" alt="Calendrier">
                <h1>Schedule an appointment</h1>
                <p>Would you like to schedule an appointment wih your Medical Visitor or your MSL ?</p>
                <button style="color: #2a41b6">Contact them</button>
            </div>
            <div class="column-topic" style="background-color: #1f2f88">
                <img style="margin-bottom: 38px" src="@/assets/svg/research.svg" alt="Etude">
                <h1>Clinical Study</h1>
                <p>Would you like to register a patient in a clinical study ?</p>
                <button style="color: #1f2f88">Register here</button>
            </div>
        </div>
    </transition>
</template>
<script>
    export default {
        name: 'ScreenEnd'
    }
</script>
<style lang="scss" scoped>
    #screen-end {
        position: fixed;
        display: flex;
        justify-content: space-around;
        align-items: center;
        width: 100%;
        height: 100%;
        .column-topic {
            height: 100%;
            width: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
            flex-flow: column;
            flex-wrap: wrap;
            text-align: center;
            padding: 25px;
            img {
                width: 25%;
                height: auto;
            }
            h1 {
                color: #fff;
                font-size: 1.875rem;
                margin: 0;
            }
            p {
                color: #fff;
                font-size: 1.5rem;
                max-width: 70%;

            }
            button {
                border: 3px solid #fff;
                background-color: #fff;
                padding: 20px 40px;
                border-radius: 50px;
                min-width: 230px;
                font-size: 1.5rem;
                font-weight: bold;
                transition: all 0.5s cubic-bezier(.25, .8, .25, 1);
                cursor: pointer;
                outline: none;
                overflow: hidden;
                position: relative;
                box-shadow: 0px 4px 10px 3px rgba(0, 0, 0, 0.2);
                &:hover {
                    box-shadow: 6px 9px 10px 0px rgba(0, 0, 0, 0.2);
                    padding-right: 50px;
                    &:after {
                        right: 5%;
                    }
                }
                &:after {
                    content: '→';
                    right: -10%;
                    transition: 400ms;
                    transition-timing-function: cubic-bezier(0.18, 0.89, 0.32, 1.28);
                    position: absolute;
                }
            }
        }
    }
</style>
